import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { ColumnVisibility } from '@/components/column-visibility'
import { SearchField } from '@/components/search-field'
import type { Table } from '@/libs/table'
import { useIntlayer } from 'react-intlayer'
import { openSheet } from '@/features/ui/store'
import type { Customer } from '../domain/customer'
import { useCustomerParams } from './use-customer-params'
import { GLOBAL_SHEET_IDS } from '@/features/ui/hooks/use-sheet'

type Props = {
	table: Table<Customer>
}

const CustomersHeader = ({ table }: Props) => {
	const content = useIntlayer('customers-page')
	const { q, setParams } = useCustomerParams()

	return (
		<div className='flex items-center justify-between gap-4'>
			<SearchField
				placeholder={content.searchPlaceholder.value}
				value={q ?? ''}
				onChange={value => setParams({ q: value })}
			/>
			<div className='flex items-center gap-2'>
				<ColumnVisibility table={table} />
				<Button variant='outline' size='icon' onClick={() => openSheet(GLOBAL_SHEET_IDS.CUSTOMER_CREATE)}>
					<Icons.Add size={16} />
				</Button>
			</div>
		</div>
	)
}

export { CustomersHeader }
